export default __webpack_public_path__ + "static/media/dm-subscriber.d08a8781.svg";